// ./modules/components/g6_css.mjs
// ==================================================
import insertCss from 'insert-css';
// --------------------------------------------------

// => tooltips styles
var tooltipCss = function tooltipCss() {
  insertCss("\n    .g6-component-tooltip {\n      background-color: #F0F0F0;\n      padding: 10px;\n      box-shadow: rgb(174, 174, 174) 0px 0px 10px;\n      width: fit-content;\n      color: #00000;\n      border-radius: 4px;\n      font-size: 12px;\n      font-family: Verdana, Arial, Helvetica, sans-serif;\n    }\n    ");
};

// => exports
export { tooltipCss };